'use strict';
import template from './listadoObservadosM.html';
import controller from './listadoObservadosM.controller';

const listadoObservadosMComponent = {
  controller,
  template
};

export default listadoObservadosMComponent;


// WEBPACK FOOTER //
// ./src/app/components/listados/lista-observadosM/listadoObservadosM.component.js